<template>
    <div class="print-text" v-if="seen">

    </div>
</template>
<style scoped>
    .print-text {
        text-align: left;
        padding: 3em 4em;
    }
</style>

<script>
import cookies from '@/services/cookies'
export default {
    data() {
        return {
            seen: false
        }
    },
    mounted() {
        this.seen = true
        
        let data = {
            id: this.$route.params.file,
            token: cookies.getCookie('token')
        }

        this.$socket.emit('loadtxt', data, function(data) {
            if(data.data === true) {
                if(data.found === 1) {
                    let div = document.querySelector('.print-text')
                    div.innerText = data.content    
                    window.print()
                }
            } else {
                that.$router.push('/login')
            }
        })
    }
}
</script>
